import { IProduct } from 'core/redux/features/products/types';
import { useEffect } from 'react';
import { FBQAddToCart, FBQViewContent } from '../../utils/fbPixel';

/**
 * Trigger ViewContent event facebook pixel event
 * @param props
 */
export function useViewContentEffect({ product }: { product: IProduct }) {
  // facebook pixel
  useEffect(() => {
    if (!product) {
      return;
    }
    const { name, id, price_sale } = product;
    FBQViewContent({
      content_name: name,
      content_ids: [id.toString()],
      content_type: 'product',
      value: price_sale,
      currency: 'DKK',
    });
  }, [product]);
}

/**
 * Trigger AddToCart event facebook pixel event
 * @param props
 */
export function useFBQFBQAddToCartEffect({
  product,
  total,
  shouldTrack,
}: {
  product: IProduct;
  total: number;
  shouldTrack: boolean;
}) {
  useEffect(() => {
    if (!shouldTrack) {
      return;
    }
    const { id } = product;

    FBQAddToCart({
      value: total,
      currency: 'DKK',
      content_type: 'product',
      content_ids: [id.toString()],
    });
  }, [product, total, shouldTrack]);
}
